
/**
 * 调整正文字体大小
 */
export default {
  props: {
    articleTarget: { type: String, default: "article p" }, // 正文所在的位置，通过 CSS Selector 定位
  },
  methods: {
    onClk(ev: Event): void {
      let el: Element = ev.target as Element;
      let setFontSize = (fontSize: string): void => {
        document.body
          .querySelectorAll(this.$props.articleTarget)
          .forEach((p: HTMLParagraphElement) => (p.style.fontSize = fontSize));
      };

      if (el.tagName == "LABEL" || el.tagName == "INPUT") {
        if (el.tagName != "LABEL") el = el.parentNode as Element;

        console.log(el);
        if (el.innerHTML.indexOf("大") != -1) setFontSize("12pt");
        else if (el.innerHTML.indexOf("中") != -1) setFontSize("10.5pt");
        else if (el.innerHTML.indexOf("小") != -1) setFontSize("9pt");
      }
    },
  },
};
